import {
    ApiContentBlock,
    ApiFullLandingPageLink,
} from '@storefronts/common-types'
import React from 'react'
import { QueryParamOverrideInput } from './queryParamOverrides'

/** Which kind of content block a section tree renders. */
export type SectionTreeScope = 'LANDING_PAGE' | 'PDP'

export type OverrideContext = {
    qpOverrides?: QueryParamOverrideInput
    mainContentOverride?: ApiContentBlock
    linkContentOverride?: ApiContentBlock
    selectedBlockIdx?: number
    /**
     * Which section tree `selectedBlockIdx` indexes into. Landing page and
     * product page trees render together (an INLINE_PDP that includes PDP body
     * content, or the product drawer opened over the preview) and each tree
     * indexes its own sections, so the editor selection only applies to the
     * tree whose content block the editor is editing.
     */
    selectedBlockScope?: SectionTreeScope
    displayPoweredByFooter?: boolean
    /** Additional products for dynamic grids (Best Sellers, OBT) in preview */
    dynamicGridProducts?: ApiFullLandingPageLink[]
}

export type OverrideInput = OverrideContext

const defaultOverrideContext: OverrideContext = {}

export const OverrideContext = React.createContext(defaultOverrideContext)

/**
 * Which content block the enclosing section tree renders. Undefined outside a
 * section tree, which keeps an editor selection from matching anything.
 */
export const SectionTreeScopeContext = React.createContext<
    SectionTreeScope | undefined
>(undefined)
